import * as R from "ramda";
import { addAppInitialForm } from "../../client/Components/Administraton/utils/constant";
const getAppRoles = (state: any) => R.pathOr([], ["AppRole", "appRolesData"], state);
const isAppRemoved = (state: any) => R.pathOr(false, ["AppRole", "isAppRemoved"], state);
const appRole = (state: any) => R.pathOr(addAppInitialForm, ["AppRole", "role"], state);
const getCheckRole = (state: any) => R.pathOr(true, ["AppRole", "getCheckRole"], state);
const isCheckRole = (state: any) => R.pathOr(true, ["AppRole", "isCheckRole"], state);
const isCheck = (state: any) => R.pathOr(true, ["AppRole", "isCheck"], state);
const addedRoleVal = (state: any) => R.pathOr(0, ["AppRole", "addedRoleVal"], state);
const updatedRoleVal = (state: any) => R.pathOr(0, ["AppRole", "updatedRoleVal"], state);

const selectors = {
  getAppRoles,
  isAppRemoved,
  appRole,
  getCheckRole,
  isCheckRole,
  isCheck,
  addedRoleVal,
  updatedRoleVal
};

export default selectors;
